import { Grid } from "../../app/core/components/grid";
import { ComboBox } from "../../app/core/components/comboBox";
import { Dialog, DialogProps } from "../../app/core/components/dialog";
import { Helper } from "../core/util/helper";
import { DialogHelper } from "../core/util/dialogHelper";
import { ComponentHelper } from "../core/util/componentHelper";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import { GridCustomToolBarButton } from "../core/components/toolBar";
import React from "react";
import ReactDOM from "react-dom";
export default class AssignmentSorting extends React.Component<AssignmentSortingProps, { selected: SortingInfo }>{
    private gridOptions: kendo.ui.GridOptions;
    private dataRole = "AssignmentSortingOrderWrapper";
    private dataSource: DSItem[] = [
        { text: Helper.getTranslation("WebCRM.Administration.AssignmentSorting.Asc"), value: "asc" },
        { text: Helper.getTranslation("WebCRM.Administration.AssignmentSorting.Desc"), value: "desc" }
    ];

    private fields: DSItem[] = [
        { value: "Start", text: "Auftrag.Start" },
        { value: "End", text: "Auftrag.Ende" },
        { value: "Id", text: "Statistik.AssignmentId" },
        { value: "ResourceId", text: "WebSMS.FlexTime.Ressnr" },
        { value: "ResourceName", text: "BrowserTitle.Resource.Available" },
        { value: "AdrNr", text: "Field.Adresse.adrnr" },
        { value: "AdrName", text: "Field.Ansprechpartner.adrname" },
        { value: "Gruppierung", text: "Field.Einsatz.gruppierung" },
        { value: "Prioritaet", text: "Standard.Priority" }
    ]


    private buttonIds = {
        new: "New",
        delete: "Delete",
        up: "up",
        down: "down"
    }

    constructor(props) {
        super(props)
        this.state = {
            selected: null
        }
        this.initApp();
    }

    private initApp = () => {
        this.fields = this.fields.map((item) => {
            const text = Helper.getTranslation(item.text);
            return {
                value: item.value,
                text: Helper.isNullOrEmpty(text) ? item.value : text
            }
        });

        this.gridOptions = {
            sortable: false,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "Pos",
                    title: Helper.getTranslation("WebCRM.Administration.AssignmentSorting.Pos")
                },
                {
                    field: "Field",
                    title: Helper.getTranslation("WebCRM.EditIndividualCategories.Field"),
                    template: (info: SortingInfo) => {
                        const field = this.fields.find(f => f.value == info.Field);
                        const text = Helper.hasValue(field) && !Helper.isNullOrEmpty(field.text) ? field.text : info.Field;
                        return `<div id='assignmentSorting_${info.Pos}'>${text}</div>`
                    }
                },
                {
                    field: "Order",
                    title: Helper.getTranslation("WebCRM.Administration.AssignmentSorting.Sorting"),
                    template: () => {
                        return `<div data-role="${this.dataRole}"><input class="dropDownTemplate"/></div>`;
                    }
                }

            ]
        };
    }

    private onChange = (value: SortingInfo[]) => {
        this.props.onChange(this.props.field, value.sort(this.sort))
    }

    private sort = (a: SortingInfo, b: SortingInfo) => {
        if (a.Pos < b.Pos) {
            return -1;
        }
        if (a.Pos > b.Pos) {
            return 1;
        }
        return 0;
    }

    private renderGrid = () => {
        let selected = this.state.selected;


        const customButtons: Array<GridCustomToolBarButton> = this.props.disabled ? [] : [
            { autoEnabledOnRecordSelected: false, caption: Helper.getTranslation("Standard.Neu"), enabled: true, iconClass: "fa-solid fa-plus", id: this.buttonIds.new },
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("Standard.Loeschen"), enabled: true, iconClass: "fa-solid fa-minus", id: this.buttonIds.delete },
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("Standard.Up"), enabled: Helper.hasValue(selected) && selected.Pos != 0, iconClass: "fa-solid fa-up", id: this.buttonIds.up },
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("Standard.Down"), enabled: Helper.hasValue(selected) && selected.Pos < (this.props.value.length - 1), iconClass: "fa-solid fa-down", id: this.buttonIds.down },
        ];

        let selectFilter: string = null;
        if (Helper.hasValue(selected)) {
            const field = this.fields.find(f => f.value == selected.Field);
            selectFilter = Helper.hasValue(field) && !Helper.isNullOrEmpty(field.text) ? field.text : selected.Field;
        }



        return (
            <div className="flex-container">
                <Grid
                    selectFilter={selectFilter}
                    customButtons={customButtons}
                    onClickCustomButton={this.onButtonClick}
                    data={this.props.value.sort(this.sort)}
                    options={this.gridOptions}
                    id="assignmentSorting"
                    onDataBound={this.onDataBound}
                    onSelectionChanged={this.onSelectionChange}
                />
            </div>
        );
    }

    private onButtonClick = (id: string, dataItem: SortingInfo) => {
        const pos = Helper.hasValue(dataItem) ? dataItem.Pos : -1;
        let posB = -1;
        switch (id) {
            case this.buttonIds.new:
                this.new();
                break;
            case this.buttonIds.delete:
                this.delete(pos);
                break;
            case this.buttonIds.up:
                posB = pos - 1;
                this.toggle(pos, posB);
                break;
            case this.buttonIds.down:
                posB = pos + 1;
                this.toggle(pos, posB);
                break;
        }
    }

    private new = async () => {
        const field = await getNewField(this.fields);
        if (Helper.isNullOrEmpty(field))
            return;
        const value = this.props.value;
        value.push({
            Order: "asc",
            Pos: value.length,
            Field: field, 
        })
        this.onChange(value);

    }

    private delete = async (pos: number) => {
        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
        if (!isOk)
            return;

        const value = this.props.value.filter(i => i.Pos != pos);
        for (let i = 0; i < value.length; i++) {
            value[i].Pos = i;
        }
        this.onChange(value);
    }

    private toggle = (posA: number, posB: number) => {
        const value = this.props.value;

        const index_a = value.findIndex(v => v.Pos == posA);
        const index_b = value.findIndex(v => v.Pos == posB);

        value[index_a].Pos = posB;
        value[index_b].Pos = posA;

        this.onChange(value);
    }

    private onSelectionChange = (item) => {
        if (Helper.hasValue(item))
            this.setState({ selected: item })
    }

    private onDataBound = (event: kendo.ui.GridDataBoundEvent) => {
        console.log("onDataBound")
        const data = event.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            const value = data[i].Order;
            const pos = data[i].Pos; 
            const input = event.sender.tbody.find(`tr[data-uid='${data[i].uid}'] .dropDownTemplate`);
            if (Helper.hasValue(input[0])) {
                $(input).kendoDropDownList({
                    value: value,
                    dataSource: this.dataSource,
                    dataTextField: "text",
                    dataValueField: "value",
                    change: (e) => {
                        const index = e.sender["selectedIndex"]
                        const ds = e.sender.dataSource.data();
                        this.onOrderChange(pos, ds[index].value);
                    },
                    enable: !this.props.disabled
                }).data("kendoDropDownList");
            }
        }
    }

    private onOrderChange = (pos: number, order: Order) => {
        const value = this.props.value;
        value[pos].Order = order;
        this.onChange(value);
    }

    render() {
        return (
            <>
                <style>
                    {
                        `span.k-dropdown{
                            width: 100%;
                        }`
                    }
                </style>
                {this.renderGrid()}
            </>
        );
    }
}

interface DSItem {
    value: string;
    text: string;
}

type Order = "asc" | "desc";

export interface SortingInfo {
    Pos: number;
    Field: string;
    Order: Order
}

interface AssignmentSortingProps extends BaseComponentProps {
    value: SortingInfo[]
}

const getNewField = (dataSource: DSItem[]) => {
    return new Promise<string>((resolve) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);

        var value = "";
        const root = ReactDOM["createRoot"](targetElement[0]);
        const dialogProps: DialogProps = {
            actions: [
                {
                    action: () => { resolve(null) },
                    label: Helper.getTranslation("Standard.Abbrechen"),
                    primary: false,
                }, {
                    action: () => {
                        resolve(value)
                    },
                    label: Helper.getTranslation("Standard.OK"),
                    primary: true
                }
            ],
            title: Helper.getTranslation("WebCRM.Administration.AssignmentSorting.NewField"),
            afterClose: () => {
                targetElement.remove();
            },
            open: true,
            width: 250
        }
        const cbProps = ComponentHelper.createFactory().getDefaultComboBoxProps();
        cbProps.value = value;
        cbProps.onChange = (_, newValue) => {
            value = newValue;
        }
        cbProps.dataSource = dataSource;
        cbProps.field.dataTextField = "text";
        cbProps.field.dataValueField = "value";

        root.render(
            <>
                <Dialog {...dialogProps} >
                    <ComboBox {...cbProps} />
                </Dialog>
            </>
        );


    })
}